import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentCompanySupportWebsite_company$key } from './__generated__/PaymentCompanySupportWebsite_company.graphql.ts';
import PaymentCompanySupportLink from './PaymentCompanySupportLink.tsx';

import type { ReactNode } from 'react';

type PaymentCompanySupportWebsiteProps = {
  company: PaymentCompanySupportWebsite_company$key;
};

const PaymentCompanySupportWebsite = (
  props: PaymentCompanySupportWebsiteProps,
): ReactNode => {
  const { t } = useTranslation();

  const company = useFragment<PaymentCompanySupportWebsite_company$key>(
    graphql`
      fragment PaymentCompanySupportWebsite_company on Company {
        preferences {
          support {
            website
          }
        }
      }
    `,
    props.company,
  );

  if (!company?.preferences?.support?.website) {
    return;
  }

  return (
    <PaymentCompanySupportLink
      title={t('Seller website')}
      href={company.preferences.support.website}
      target='_blank'
      rel='noopener noreferrer'
    >
      {company.preferences.support.website}
    </PaymentCompanySupportLink>
  );
};

export default PaymentCompanySupportWebsite;
